export default async ({ route, redirect }) => {
  if (route.query.is_business) {
    return redirect({ path: '/business/continue' })
  }
}
